module.exports = __webpack_public_path__ + "img/stickers-portfolio2.b2f60b2d.png";